const DEFAULT_SUGGESTIONS = ['whatCanYouDo', 'devices', 'sms'];

const SUGGESTIONS_BY_ROUTE: Record<string, string[]> = {
  dashboard: ['tomorrow', 'sms', 'modules'],
  'settings.treatment_library': ['addDevice', 'devices', 'deviceVersusTreatment'],
  'settings.integrations': ['sms', 'calendarSync', 'twilioNeeds'],
  'settings.services': ['services', 'addService', 'whatCanYouDo'],
  patient_detail: ['findRecords', 'tomorrow', 'whatCanYouDo'],
};

export function resolveAssistantSuggestionKeys(routeKey: string | null): string[] {
  if (routeKey === null) {
    return DEFAULT_SUGGESTIONS;
  }
  const suggestions = SUGGESTIONS_BY_ROUTE[routeKey];
  return suggestions === undefined ? DEFAULT_SUGGESTIONS : suggestions;
}
